import { createApi } from '@reduxjs/toolkit/query/react';
import { GuidT } from '@/types/common';
import { CityModelDataResultIF, CityModelIF } from '@/api/citiesApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const citiesApi = createApi({
    reducerPath: 'citiesApi',
    baseQuery: fetchRestApiQuery('/Cities'),
    tagTypes: ['Cities'],
    endpoints: (builder) => ({
        searchCities: builder.query<CityModelDataResultIF, string | undefined>({
            query: (text) => ({
                url: '',
                params: {
                    Text: text,
                },
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                          { type: 'Cities', id: 'LIST' },
                          ...result.data.map((item: CityModelIF) => ({
                              type: 'Cities' as const,
                              id: item.guid,
                          })),
                      ]
                    : [{ type: 'Cities', id: 'LIST' }],
        }),
        getCityById: builder.query<CityModelIF, GuidT>({
            query: (cityGuid) => ({
                url: `/${cityGuid}`,
            }),
        }),
    }),
});
